.ic-question{width:100%}.ic-question .ic-question__header{display:flex;align-items:flex-start;margin-bottom:15px}.ic-question .ic-question__title{font-weight:400;font-size:16px;font-family:GothamBookMedium,sans-serif}
/*# sourceMappingURL=question-wrapper.component-XKMF7A6U.css.map */
